import {  CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmSelectComponent } from './sm-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmErrorModule } from '../sm-error/sm-error.module';



@NgModule({
  declarations: [SmSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SmErrorModule
  ],
  exports :[SmSelectComponent],
 


})
export class SmSelectModule { }
